/**
 * Client Portal View Registry (SO-P274, E4.b)
 * Typed registry mapping subjectType -> view renderer component.
 * Allows new subject portals (e.g. SITES_CLIENT in G5) to be added with a single registry entry.
 */

import type { ComponentType } from 'react'
import type { ClientPortalDeliveryView, OpsClientLink } from '../../types/ops'
import { DeliveryClientPortalView } from './DeliveryClientPortalView'

export interface ClientPortalViewProps<V = unknown> {
  token: string
  view: V
  link: OpsClientLink | null
  onRefresh: () => Promise<void>
  onSignOut: () => Promise<void>
}

export type ClientViewRenderer = ComponentType<ClientPortalViewProps<ClientPortalDeliveryView>>

export const CLIENT_VIEW_REGISTRY: Record<string, ClientViewRenderer> = {
  DELIVERY_ENGAGEMENT: DeliveryClientPortalView,
}

export function getClientViewRenderer(subjectType: string | null | undefined): ClientViewRenderer | undefined {
  if (!subjectType) return undefined
  return CLIENT_VIEW_REGISTRY[subjectType]
}
